import React, { FC, memo } from "react";
import Button from "components/Button/Button";
import ButtonRow from "components/ButtonRow";
import { ButtonColor, ButtonVariant } from "enums/Button";
import { useTranslation } from "react-i18next";
import { Heading, Placeholder, Wrapper } from "./CancelPacking.styles";

interface CancelPackingProps {
  handleConfirmPacking: () => void;
  handleCancelPacking: () => void;
}

const CancelPacking: FC<CancelPackingProps> = ({
  handleConfirmPacking,
  handleCancelPacking,
}) => {
  const { t } = useTranslation("common");

  return (
    <Wrapper>
      <Heading>
        {t("common.areYouSureYouWantTo")}
        <span> {t("parcels.cancel")} </span>
        {t("parcels.packingInGenitive")}?
      </Heading>
      <Placeholder>{t("parcels.cancelPackingMessage")}</Placeholder>
      <ButtonRow>
        <Button onClick={handleConfirmPacking}>
          {t("parcels.continuePacking")}
        </Button>
        <Button
          onClick={handleCancelPacking}
          color={ButtonColor.Danger}
          variant={ButtonVariant.Filled}
        >
          {t("parcels.confirmCancelPacking")}
        </Button>
      </ButtonRow>
    </Wrapper>
  );
};

export default memo(CancelPacking);
